import {
  ASSETS,
  ASSETS_ID,

  SET_USER,
  SET_DURATION,
  SET_ATTACHMNET,
  SET_ASSETS_ID,
  SET_RENEWAL_DURATION,

  SEARCH_ASSERTS,
  SET_CUSTOMERID,
  SET_CAT,
  SET_FNAME,
  SET_MNAME,
  SET_GENDER,
  SET_DISABILITIES,
  SET_WPNO,
  SET_STATE,
  SET_DIST,
  SET_BLOCK,
  SET_VILLAGE,
  SET_PIN,
  SET_TEN_SCL,
  SET_TEN_SCL_BOARD,
  SET_TEN_SCL_PASS,

  SET_TEN_SCL_FULLMARK,
  SET_TEN_SCL_FULLMARK_SEC,
  SET_CLG,
  SET_CLG_BOARD,
  SET_CLG_PASS,
  SET_CLG_FULLMARK,
  SET_CLG_FULLMARK_SEC,
  SET_CLG_NEET,
  SET_CLG_NEETATM,
  SET_CITY_CENTER,
  SET_STUDY_CENTER,
  SET_PROFILE_PIC,
  SET_USER_DATA,
  SET_PER,
  SET_HOSTEL,
  SET_MEDIUM,
  SET_TYPE,
  SET_EMAIL
} from "./constant";
const initial_state = {
  assets: [],
  assets_by_id: [],
  search_asserts: [],

  userdeatils: [],
  user_all_data: [],
  setDuration: "",
  setAttachmnet: "",
  setAssetsId: "",
  setRenewalDuration: "",
  cat_id:"",
  cat_nam:"",
  fname:"",
  Mname:'',
  gender:"",
  disabilities:"",
  wpno:"",
  state:"",
  dist:"",
  block:"",
  village:"",
  pin:"",
  school:"",
  schoolboard:"",
  schoolpass:"",
  schoolfullmark:"",
  schoolfullmarksec:"",
  clg:"",
  clgboard:"",
  clgpass:"",
  clgfullmark:"0",
  fullmarksecclg:"0",
  neet:"0",
  neetatm:"0",
  examcenter:"",
  studycenter:"",
  profilepic:"",
  schooltype:"",
  medium:"",
  hostel:"",
  email:"",
  per:"0",



};
export default function reducer(state = initial_state, action) {
  switch (action.type) {

    case ASSETS:
      return {
        ...state,
        assets: action.payload, search_asserts: action.payload
      };
    case SET_USER_DATA:
      return {
        ...state,
        assets: action.payload, user_all_data: action.payload
      };
    case ASSETS_ID:
      return state = { ...state, assets_by_id: action.payload };

    case SET_USER:
      return state = { ...state, userdeatils: action.payload };
    case SET_DURATION:
      return state = { ...state, setDuration: action.payload };
    case SET_ATTACHMNET:
      return state = { ...state, setAttachmnet: action.payload };
    case SET_ASSETS_ID:
      return state = { ...state, setAssetsId: action.payload };
    case SET_RENEWAL_DURATION:
      return state = { ...state, setRenewalDuration: action.payload };

    case SEARCH_ASSERTS:
      return {
        ...state,
        search_asserts: action.payload
      };
    case SET_CUSTOMERID:
      return {
        ...state,
        cat_id: action.payload
      };
    case SET_CAT:
      return {
        ...state,
        cat_nam: action.payload
      };
    case SET_FNAME:
      return {
        ...state,
        fname: action.payload
      };
    case SET_MNAME:
      return {
        ...state,
        Mname: action.payload
      };
    case SET_GENDER:
      return {
        ...state,
        gender: action.payload
      };
    case SET_DISABILITIES:
      return {
        ...state,
        disabilities: action.payload
      };
    case SET_WPNO:
      return {
        ...state,
        wpno: action.payload
      };
    case SET_STATE:
      return {
        ...state,
        state: action.payload
      };
    case SET_DIST:
      return {
        ...state,
        dist: action.payload
      };
    case SET_BLOCK:
      return {
        ...state,
        block: action.payload
      };
    case SET_VILLAGE:
      return {
        ...state,
        village: action.payload
      };
    case SET_PIN:
      return {
        ...state,
        pin: action.payload
      };
    case SET_TEN_SCL:
      return {
        ...state,
        school: action.payload
      };
    case SET_TEN_SCL_BOARD:
      return {
        ...state,
        schoolboard: action.payload
      };
    case SET_TEN_SCL_PASS:
      return {
        ...state,
        schoolpass: action.payload
      };
    case SET_TEN_SCL_FULLMARK:
      return {
        ...state,
        schoolfullmark: action.payload
      };
    case SET_TEN_SCL_FULLMARK_SEC:
      return {
        ...state,
        schoolfullmarksec: action.payload
      };
    case SET_CLG:
      return {
        ...state,
        clg: action.payload
      };
    case SET_CLG_BOARD:
      return {
        ...state,
        clgboard: action.payload
      };
    case SET_CLG_PASS:
      return {
        ...state,
        clgpass: action.payload
      };
    case SET_CLG_FULLMARK:
      return {
        ...state,
        clgfullmark: action.payload
      };
    case SET_CLG_FULLMARK_SEC:
      return {
        ...state,
        fullmarksecclg: action.payload
      };
    case SET_CLG_NEET:
      return {
        ...state,
        neet: action.payload
      };
    case SET_CLG_NEETATM:
      return {
        ...state,
        neetatm: action.payload
      };
    case SET_CITY_CENTER:
      return {
        ...state,
        examcenter: action.payload
      };
    case SET_STUDY_CENTER:
      return {
        ...state,
        studycenter: action.payload
      };
    case SET_PROFILE_PIC:
      return {
        ...state,
        profilepic: action.payload
      };
    case SET_PER:
      return {
        ...state,
        per: action.payload
      };
    case SET_HOSTEL:
      return {
        ...state,
        hostel: action.payload
      };
    case SET_MEDIUM:
      return {
        ...state,
        medium: action.payload
      };
    case SET_TYPE:
      return {
        ...state,
        schooltype: action.payload
      };
    case SET_EMAIL:
      return {
        ...state,
        email: action.payload
      };
    default:
      return state;
  }
}
